/* eslint-disable no-console */
import React from 'react';
import './style.scss';
import { Link } from 'gatsby';

const Footer = () => (
    <footer className="footer-container">
        <div className="footer-links content">
            <Link to="contact" className="is-size-6-touch is-size-5-desktop">
                Contact Us
            </Link>

            <Link to="/certificates" className="is-size-6-touch is-size-5-desktop">
                Certificates
            </Link>

            {/* <Link to="/" className="is-size-6-touch is-size-5-desktop"> */}
            {/* Wholesale */}
            {/* </Link> */}

            <Link to="/shipping-and-returns" className="is-size-6-touch is-size-5-desktop">
                Shipping & Returns
            </Link>

            <Link to="/terms-and-conditions" className="is-size-6-touch is-size-5-desktop">
                Terms & Conditions
            </Link>

            <Link to="/privacy-policy" className="is-size-6-touch is-size-5-desktop">
                Privacy Policy
            </Link>

            <a
                href="https://www.facebook.com/DrWatsonCBD"
                target="_blank"
                rel="noopener noreferrer"
                className="is-size-6-touch is-size-5-desktop"
            >
                <span className="icon is-primary">
                    <i className="fab fa-facebook" />
                </span>
            </a>

            <a
                href="http://instagram.com/drwatsoncbd"
                target="_blank"
                rel="noopener noreferrer"
                className="is-size-6-touch is-size-5-desktop"
            >
                <span className="icon is-primary">
                    <i className="fab fa-instagram" />
                </span>
            </a>
        </div>
    </footer>
);

export default Footer;
